import { useEffect, useRef, useCallback } from 'react'

const TIMEOUT_MS = 120 * 60 * 1000  // 2 hours — field agents on active shifts
const WARNING_MS =   5 * 60 * 1000  // warn 5 minutes before

const EVENTS = ['mousedown', 'mousemove', 'keydown', 'touchstart', 'scroll', 'click']

export function useInactivityTimeout({ onTimeout, onWarning, onActivity, enabled = true }) {
  const timeoutRef = useRef(null)
  const warningRef = useRef(null)
  const warnedRef  = useRef(false)

  const reset = useCallback(() => {
    clearTimeout(timeoutRef.current)
    clearTimeout(warningRef.current)

    if (warnedRef.current) {
      warnedRef.current = false
      onActivity?.()
    }

    if (!enabled) return

    warningRef.current = setTimeout(() => {
      warnedRef.current = true
      onWarning?.()
    }, TIMEOUT_MS - WARNING_MS)

    timeoutRef.current = setTimeout(() => {
      onTimeout?.()
    }, TIMEOUT_MS)
  }, [enabled, onTimeout, onWarning, onActivity])

  useEffect(() => {
    if (!enabled) return

    reset()

    EVENTS.forEach(e => window.addEventListener(e, reset, { passive: true }))

    return () => {
      clearTimeout(timeoutRef.current)
      clearTimeout(warningRef.current)
      EVENTS.forEach(e => window.removeEventListener(e, reset))
    }
  }, [enabled, reset])
}
